<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="_idContainer003" role="doc-chapter">
<p class="pl-title"><a id="_idTextAnchor001"></a>The Texan’s Inherited Family</p>
<p class="pl-author">Noelle Marchand</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Texans_Inherited_Family.vue?7dce288f